import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';

import type { MinistryIconKey } from '@escala/domain/types';

import { MINISTRY_ICON_COMPONENTS } from './MinistryIcon';

/**
 * O ícone do ministério como SVG em texto, na cor pedida — para o que não é tela, como o
 * canvas das imagens e dos PDFs exportados. O mesmo desenho do `MinistryIcon` (lucide),
 * montado num elemento solto e lido de volta; sem chave conhecida, `null`.
 */
export function ministryIconSvg(icon: MinistryIconKey, color: string, size = 64): string | null {
  const Icon = MINISTRY_ICON_COMPONENTS[icon] as
    (typeof MINISTRY_ICON_COMPONENTS)[MinistryIconKey] | undefined;

  if (!Icon) return null;

  const host = document.createElement('div');
  const root = createRoot(host);

  flushSync(() => root.render(<Icon color={color} size={size} strokeWidth={2.2} aria-hidden />));

  const svg = host.innerHTML;

  root.unmount();

  return svg || null;
}
